import {createSelector} from 'reselect';

const getRoot = state => state;
const getInterventionsState = createSelector(getRoot, state => state.fetchInterventions);

export const getCounters = createSelector(getInterventionsState, ({counters}) => counters);
export const getFilters = createSelector(getInterventionsState, ({filters}) => filters);
export const getInterventions = createSelector(getInterventionsState, ({interventions}) => interventions);
export const getLoading = createSelector(getInterventionsState, ({loading}) => loading);
export const getPagination = createSelector(getInterventionsState, ({pagination}) => pagination);

export const isLoadingInterventions = createSelector(getInterventionsState, ({loading}) => loading);
export const isShowingArchived = createSelector(getFilters, ({showArchived}) => showArchived);
export const isShowingOnlyMine = createSelector(getFilters, ({showOnlyMine}) => showOnlyMine);
